const eventFixedFieldsLabel = 
    {
        "Type" : {"name": "Event Type", format: "filterInList"},
        "StartDate" : {"name": "Start Date", "format" : "MM-DD-YYYY"},
        "StartTime" : {"name": "Start Time", "format" : "hh:mm A"},
        "EndDate" : {"name": "End Date", "format" : "MM-DD-YYYY"},
        "EndTime" : {"name": "End Time", "format" : "hh:mm A"},
        "PointOfContact" : {"name": "Point Of Contact"},
        "DressCode" : {"name": "DressCode"},
    }

export default eventFixedFieldsLabel;